"use client"

import { useEffect } from "react"
import { installActionSkewSensor } from "@/lib/deploy/actionSkew"

/**
 * Monta el sensor de skew de Server Actions (ver lib/deploy/actionSkew.ts):
 * un POST de action que responde 404 = la tablet corre un bundle que el
 * deployment vivo ya no reconoce. No renderiza nada — su única salida es
 * VERSION_SKEW_EVENT, que BuildWatcher ya escucha para ofrecer la recarga.
 */
export function ActionSkewSensor() {
  useEffect(() => installActionSkewSensor(), [])
  return null
}
